import React, { useState } from "react";
import { maintenanceApi, MaintConnector } from "../../../api/maintenance";
import { X } from "lucide-react";
import { useNotice } from "../shared/useNotice";

interface ConnectorOverrideProps {
  deviceId: number;
  connector: MaintConnector;
  onClose: () => void;
  onComplete: () => void;
}

const STATUS_OPTIONS = [
  "Available",
  "Charging",
  "Unavailable",
  "Faulted",
  "Preparing",
  "Finishing",
  "SuspendedEVSE",
  "SuspendedEV",
  "Offline",
];

const ConnectorOverride: React.FC<ConnectorOverrideProps> = ({
  deviceId, connector, onClose, onComplete
}) => {
  const [statusName, setStatusName] = useState("");
  const [notes, setNotes] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useNotice("error", "");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!statusName) {
      setError("Select a target status");
      return;
    }
    setSubmitting(true);
    setError("");
    try {
      await maintenanceApi.overrideConnectorStatus(deviceId, connector.id, {
        status_name: statusName,
        notes: notes.trim() || undefined,
      });
      onComplete();
    } catch (err: any) {
      setError(err?.response?.data?.detail || "Failed to override status");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="maint-form-overlay">
      <div className="maint-form-card">
        <div className="maint-form-header">
          <h3>Override Connector Status</h3>
          <button onClick={onClose} className="maint-btn-icon"><X size={18} /></button>
        </div>
        <p style={{ marginBottom: "12px", color: "#666" }}>
          Connector: <strong>{connector.connector_name}</strong> | Current status: <strong>{connector.status || "Unknown"}</strong>
        </p>
        <form onSubmit={handleSubmit}>
          <label>
            Target Status *
            <select value={statusName} onChange={(e) => setStatusName(e.target.value)} required>
              <option value="">Select status...</option>
              {STATUS_OPTIONS.map((s) => (
                <option key={s} value={s}>{s}</option>
              ))}
            </select>
          </label>
          <label>
            Reason / Notes
            <textarea value={notes} onChange={(e) => setNotes(e.target.value)} rows={3} placeholder="Why is this override needed?" />
          </label>
          {error && <p className="maint-form-error">{error}</p>}
          <div className="maint-form-actions">
            <button type="button" onClick={onClose} className="maint-btn-secondary">Cancel</button>
            <button type="submit" disabled={submitting} className="maint-btn-primary">
              {submitting ? "Overriding..." : "Override Status"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ConnectorOverride;
